import React from 'react';
import { skills } from '../../data/mock';

const SkillsSection = () => {
  const skillCategories = [
    { title: 'Languages', items: skills.languages, icon: '📝' },
    { title: 'Technologies', items: skills.technologies, icon: '⚙️' },
    { title: 'Tools', items: skills.tools, icon: '🔧' },
    { title: 'Expertise', items: skills.expertise, icon: '🌟' }
  ];

  return (
    <div className="window mb-6">
      <div className="window-header">
        <span>💪 Skills & Tools 💪</span>
      </div>
      <div className="window-body">
        <div className="grid md:grid-cols-2 gap-4">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-pink-50 to-purple-50 p-4 border-4 border-dotted border-pink-400"
            >
              <h3 className="text-lg font-bold mb-3 pixel-text flex items-center gap-2" style={{ color: '#b06cff' }}>
                <span>{category.icon}</span>
                {category.title}
              </h3>
              <div className="flex flex-wrap gap-2">
                {category.items.map((item, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 bg-white text-xs font-bold border-2 border-gray-400 hover:border-pink-400 transition-colors cursor-default"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillsSection;
